// おちゃのこ page/2511 の <style> をそのまま移したもの。
//
// 素のタグセレクタを使わず全て .opptrack 配下にスコープしてある（ocnk手順書1-4）。
// 店のテーマCSSを壊さないための作法なので、セレクタの形は変えないこと。
// 見た目を変える意図が無い限り、この文字列は原文のまま維持する。

export const css = `
.opptrack{
  --ot-ink:#17242a; --ot-muted:#5c7078; --ot-faint:#8798a0; --ot-line:#dde5e8;
  --ot-surface:#ffffff; --ot-surface2:#f5f8f9; --ot-accent:#0e7c86; --ot-accent-ink:#fff;
  --ot-accent-soft:#d8ecee; --ot-warn:#b7791f; --ot-warn-soft:#f6ead2;
  --ot-danger:#a8404c; --ot-danger-soft:#f3dde0;
  max-width:600px; margin:0 auto; color:var(--ot-ink);
  font-family:"Hiragino Kaku Gothic ProN","Hiragino Sans","Yu Gothic","Meiryo",sans-serif;
  line-height:1.65; text-align:left;
}
.opptrack *{ box-sizing:border-box; }
.opptrack .ot-head{ background:var(--ot-accent-soft); border:1px solid var(--ot-accent); border-radius:12px;
  padding:14px 16px; text-align:center; }
.opptrack .ot-head .ot-title{ font-size:19px; font-weight:800; color:var(--ot-accent); }
.opptrack .ot-thanks-top{ font-size:16px; font-weight:800; color:var(--ot-accent); margin:14px 0 2px; }
.opptrack .ot-lead{ color:var(--ot-muted); font-size:13.5px; margin:0 0 18px; }
.opptrack .ot-card{ background:var(--ot-surface); border:1px solid var(--ot-line); border-radius:14px;
  box-shadow:0 1px 2px rgba(23,36,42,.06),0 8px 30px rgba(23,36,42,.06); padding:22px; }
.opptrack .ot-form{ display:grid; gap:14px; }
.opptrack .ot-label{ display:grid; gap:6px; font-size:13px; font-weight:700; color:var(--ot-ink); }
.opptrack .ot-hint{ font-weight:400; color:var(--ot-faint); font-size:12px; }
.opptrack input.ot-input{ width:100%; padding:12px 13px; font-size:15px; color:var(--ot-ink);
  background:var(--ot-surface2); border:1px solid var(--ot-line); border-radius:10px;
  font-variant-numeric:tabular-nums; font-family:inherit; }
.opptrack input.ot-input:focus-visible{ outline:2px solid var(--ot-accent); outline-offset:1px; border-color:transparent; }
.opptrack button.ot-btn{ font-family:inherit; cursor:pointer; border:none; border-radius:10px;
  font-size:15px; font-weight:700; padding:12px 18px; background:var(--ot-accent); color:var(--ot-accent-ink); transition:filter .15s ease; }
.opptrack button.ot-btn:hover{ filter:brightness(1.06); }
.opptrack button.ot-btn:disabled{ opacity:.6; cursor:default; }
.opptrack button.ot-btn:focus-visible{ outline:2px solid var(--ot-ink); outline-offset:2px; }
.opptrack .ot-delay{ margin:12px 0 0; font-size:12px; color:var(--ot-faint); }

.opptrack .ot-loading{ display:none; margin-top:6px; font-size:14px; color:var(--ot-muted); }
.opptrack .ot-loading.ot-show{ display:block; animation:opptrackFadeIn .2s ease both; }
/* 消えるときも間を取る。即 display:none にすると結果と瞬時に入れ替わって「ぱかぱか」して見える */
.opptrack .ot-loading.ot-out{ animation:opptrackFadeOut .22s ease both; }
@keyframes opptrackFadeIn{ from{opacity:0;} to{opacity:1;} }
@keyframes opptrackFadeOut{ from{opacity:1;} to{opacity:0;} }

.opptrack .ot-result{ display:none; margin-top:6px; }
.opptrack .ot-result.ot-show{ display:block; }
/* まず枠だけを下に伸ばし（中身は隠したまま）、伸びきってから中身をフェードインさせる。
   高さは JS が実測して入れる（auto は transition できない）。*/
.opptrack .ot-result.ot-grow{ overflow:hidden; transition:height .42s cubic-bezier(.22,.61,.36,1); }
.opptrack .ot-result.ot-grow > *{ opacity:0; }
.opptrack .ot-result.ot-fadein > *{ animation:opptrackFadeIn .4s ease both; }
.opptrack .ot-rhead{ background:var(--ot-surface2); border:1px solid var(--ot-line); border-radius:10px;
  padding:8px 12px; font-size:14px; font-weight:800; color:var(--ot-ink); margin-bottom:12px; }
.opptrack .ot-meta{ display:flex; justify-content:space-between; align-items:baseline; gap:12px; flex-wrap:wrap; }
.opptrack .ot-ordno{ font-size:13px; color:var(--ot-muted); }
.opptrack .ot-ordno b{ color:var(--ot-ink); font-variant-numeric:tabular-nums; letter-spacing:.02em; }
.opptrack .ot-orddate{ font-size:12.5px; color:var(--ot-faint); font-variant-numeric:tabular-nums; }
.opptrack .ot-greet{ font-size:15px; font-weight:700; color:var(--ot-ink); margin:8px 0 2px; }
/* API は氏名を返さないので常に空。要素は残したまま余白だけ消す。 */
.opptrack .ot-greet:empty{ display:none; }
.opptrack .ot-pay{ font-size:13px; color:var(--ot-muted); margin:2px 0 0; }

/* ===== 縦型ステッパー ===== */
.opptrack .ot-vsteps{ margin:16px 0 4px; }
.opptrack .ot-vitem{ position:relative; padding:0 0 20px 44px; }
.opptrack .ot-vitem:last-child{ padding-bottom:2px; }
.opptrack .ot-vitem::before{ content:""; position:absolute; left:15px; top:6px; bottom:0; width:2px; background:var(--ot-line); }
.opptrack .ot-vitem:last-child::before{ display:none; }
.opptrack .ot-vitem.ot-done::before{ background:var(--ot-accent); }
.opptrack .ot-vdot{ position:absolute; left:0; top:-2px; width:32px; height:32px; border-radius:50%; z-index:1;
  display:grid; place-items:center; background:var(--ot-surface); border:2px solid var(--ot-line); color:var(--ot-faint); font-size:13px; font-weight:700; }
.opptrack .ot-vitem.ot-done .ot-vdot{ background:var(--ot-accent); border-color:var(--ot-accent); color:#fff; }
.opptrack .ot-vitem.ot-current .ot-vdot{ background:var(--ot-accent); border-color:var(--ot-accent); color:#fff; box-shadow:0 0 0 4px var(--ot-accent-soft); font-size:11px; }
.opptrack .ot-vlabel{ font-size:15px; font-weight:700; color:var(--ot-faint); }
.opptrack .ot-vitem.ot-done .ot-vlabel{ color:var(--ot-ink); }
.opptrack .ot-vitem.ot-current .ot-vlabel{ color:var(--ot-accent); }
.opptrack .ot-vdate{ font-size:12px; font-weight:400; color:var(--ot-faint); margin-left:8px; font-variant-numeric:tabular-nums; }
.opptrack .ot-vdesc{ font-size:12.5px; color:var(--ot-muted); margin-top:3px; }
.opptrack .ot-veta{ font-size:12.5px; color:var(--ot-warn); margin-top:3px; font-weight:600; }
@media (prefers-reduced-motion: no-preference){
  .opptrack .ot-vitem.ot-current .ot-vdot::after{ content:""; position:absolute; inset:-2px; border-radius:50%;
    border:2px solid var(--ot-accent); animation:opptrackPulse 1.8s ease-out infinite; }
  @keyframes opptrackPulse{ 0%{opacity:.6; transform:scale(1);} 100%{opacity:0; transform:scale(1.6);} }
}
.opptrack .ot-cancel{ margin:14px 0; padding:12px 14px; border-radius:10px; background:var(--ot-danger-soft); color:var(--ot-danger); font-size:14px; font-weight:600; }

/* 発送済みステップ内の追跡ボックス */
.opptrack .ot-track2{ margin-top:8px; background:var(--ot-surface2); border:1px solid var(--ot-line); border-radius:10px; padding:12px 14px; }
.opptrack .ot-trow{ font-size:14px; margin:2px 0; }
.opptrack .ot-numlink{ font-weight:800; color:var(--ot-accent); text-decoration:underline; font-variant-numeric:tabular-nums;
  background:none; border:none; padding:0; font-family:inherit; font-size:14px; cursor:pointer; letter-spacing:.02em; }
.opptrack .ot-numlink:hover{ filter:brightness(1.1); }
.opptrack .ot-t2note{ margin:8px 0 0; font-size:11.5px; color:var(--ot-faint); }

.opptrack .ot-refresh{ margin-top:14px; text-align:center; }
.opptrack .ot-refresh .ot-btn{ background:var(--ot-surface2); color:var(--ot-accent); border:1px solid var(--ot-accent); font-size:13px; padding:9px 16px; }
.opptrack .ot-updated{ margin-top:12px; text-align:right; font-size:11.5px; color:var(--ot-faint); font-variant-numeric:tabular-nums; }
.opptrack .ot-live{ margin-top:10px; text-align:center; font-size:11.5px; color:var(--ot-faint); }
.opptrack .ot-msg{ display:none; margin-top:16px; padding:14px 16px; border-radius:12px; font-size:14px; font-weight:600; }
.opptrack .ot-msg.ot-show{ display:block; }
.opptrack .ot-msg.ot-err{ background:var(--ot-danger-soft); color:var(--ot-danger); border:1px solid rgba(168,64,76,.3); }

/* ご案内（常時表示） */
.opptrack .ot-guide{ margin-top:16px; background:var(--ot-surface2); border:1px solid var(--ot-line); border-radius:12px; padding:16px 18px; }
.opptrack .ot-guide h3{ margin:0 0 8px; font-size:13px; color:var(--ot-muted); font-weight:700; }
.opptrack .ot-guide ul{ margin:0; padding-left:1.1em; }
.opptrack .ot-guide li{ font-size:12.5px; color:var(--ot-muted); margin:4px 0; line-height:1.6; }
`
